module.exports = __webpack_public_path__ + "static/media/icon-button-send.237129cd.svg";